<template>
    <el-dialog
        title="技术"
        :visible.sync="isVisible"
        :close-on-click-modal="false"
    >
        <el-form
            :model="form"
            label-position="top"
            ref="form"
        >
            <el-form-item label="封面">
                <ox-uploader
                    :drag="false"
                    accept=".jpg,.png,.jpeg"
                    list-type="picture-card"
                    category-id="5ec8993c39f1b0768b58ce24"
                    :file-list="form.cover?[form.cover]:[]"
                    @success="onCoverUploaded"
                    @remove="onCoverRemoved"
                />
            </el-form-item>
            <el-row :gutter="15">
                <el-col :span="20">
                    <el-form-item label="名称">
                        <el-input
                            v-model="form.name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="优先级">
                        <el-checkbox v-model="form.top">置顶</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="分类">
                        <ox-select
                            schema="domain"
                            label-field="name"
                            v-model="form.domain"
                            :query="domainQuery"
                            style="width: 100%"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="公司">
                        <el-input :value="company.name" v-if="company" disabled/>
                        <ox-select
                            v-else
                            schema="company"
                            label-field="name"
                            v-model="form.company"
                            style="width: 100%"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="联系人">
                        <el-input
                            v-model="form.contact"
                            autocomplete="off"
                            style="width: 100%"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人电话">
                        <el-input
                            v-model="form.phone"
                            autocomplete="off"
                            style="width: 100%"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="简介">
                <el-input
                    v-model="form.brief"
                    autocomplete="off"
                    style="width: 100%"
                ></el-input>
            </el-form-item>
            <el-form-item label="详细介绍">
                <ox-editor
                    category-id="5ec8993c39f1b0768b58ce24"
                    v-model="form.description"
                />
            </el-form-item>
        </el-form>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                @click="hide"
                round
            >取 消</el-button>
            <el-button
                type="primary"
                @click="save"
                round
                :loading="isProcessing"
            >确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OxUploader from "../../ox/components/form/OxUploader";
import OxSelect from "../../ox/components/form/OxSelect";
import OxEditor from "../../ox/components/form/OxEditor";

export default {
    name: "DemandFormDialog",
    props: {
        company:{
            type: Object,
            value: function(){
                return null;
            }
        }  
    },
    components: {
        OxSelect,
        OxUploader,
        OxEditor
    },
    computed: {
        domainQuery() {
            const query = new window.BaaS.Query();
            query.compare("category", "=", "technique");
            return query;
        }
    },
    data: function() {
        return {
            isProcessing: false,
            isVisible: false,
            form: {
                id: null,
                cover: null,
                name: null,
                domain: null,
                contact: null,
                phone: null,
                brief: null,
                description: null,
                company: this.company?this.company.id: null,
                top: false,
            }
        };
    },
    methods: {
        reset() {
            this.form = {
                id: null,
                cover: null,
                name: null,
                domain: null,
                contact: null,
                phone: null,
                brief: null,
                description: null,
                company: this.company?this.company.id: null,
                top: false,
            };
        },
        show(data = null) {
            if (data) {
                this.form = {
                    id: data.id,
                    cover: data.cover,
                    name: data.name,
                    domain: data.domain.id,
                    contact: data.contact,
                    phone: data.phone,
                    brief: data.brief,
                    description: data.description,
                    company: data.company.id,
                    top: data.top
                };
                if (this.form.cover) {
                    this.form.cover.url = this.form.cover.path;
                }
            } else {
                this.reset();
            }
            this.isVisible = true;
        },
        hide() {
            this.isVisible = false;
        },
        onCoverUploaded(resp, file) {
            this.form.cover = file;
        },
        onCoverRemoved() {
            this.form.cover = null;
        },
        save() {
            this.isProcessing = true;
            this.$ox
                .service("technique")
                .save(this.form)
                .then(res => {
                    this.$notify.success({
                        title: "操作成功",
                        message: `技术“${this.form.name}”已保存`
                    });
                    this.hide();
                    this.$refs.form.resetFields();
                    this.$refs.form.clearValidate();
                    this.$emit("success", res);
                })
                .catch(err => {
                    this.$emit("error", err);
                    this.$notify.error({
                        title: "操作失败",
                        message: "技术信息保存失败，请与系统维护人员联系"
                    });
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        }
    }
};
</script>

<style scoped>
</style>